import React, { useState, useEffect } from 'react'
import { alertActions, regisActions } from '../../../store/actions'
import history from '../../../route/history'
import { connect } from 'react-redux'
import Alert from '../../../module/alert/Alert'
import PolicyTerms from '../PolicyTerms'
import EssentialPrivacy from '../essentialPrivacy'
import OptionalPrivacy from '../optionalPrivacy'

const RegisStep0 = (props) => {
  const [isManager, setIsManager] = useState(false)
  const [userInfo, setUserInfo] = useState({})
  const [allCheck, setAllCheck] = useState(false)
  const [showPrivacy, setShowPrivacy] = useState(false)
  const [htmlCode, setHtmlCode] = useState()
  const [title, setTitle] = useState()

  const [state, setState] = useState({
    tosAgreYn: { title: '이용약관', require: true, agree: false, show: false },
    privacyAgreYn: { title: '(필수)개인정보 수집 및 이용내역', require: true, agree: false, show: false },
    checkedJoinFlag: '',
    bplcCd: props.location.state?.bplcCd,
  })

  useEffect(() => {
    let value = props.checkedJoinFlag
    const search = props.location.search
    const params = new URLSearchParams(search)
    const invtId = params.get('invtId')

    if (value === 'corp' || value === 'uth') {
      setIsManager(true)
      setUserInfo({...userInfo, bplcCd: state?.bplcCd})
    } else if (value === 'user') {
      console.log('개인회원')
    } else if (invtId) {
      // 초대메일 클릭해서 들어올 때 /regis?invtId=1651481310283 이런식으로 들어옴
      setUserInfo({ ...userInfo, invtId: invtId })
      props.getInviteInfo(invtId)
    } else {
      props.success({
        title: '오류',
        message: '잘못된 접근입니다.',
        params: {
          type: 'SUCCESS',
          callback: () => {
            window.location.replace('/regis/Join')
          },
        },
      })
    }
  }, [])

  useEffect(() => {
    props?.inviteInfo &&
    setUserInfo({
      ...userInfo,
      groupCode: props.inviteInfo?.groupCode,
      email: props.inviteInfo?.email,
      memberName: props.inviteInfo?.userName,
    })
  }, [props.inviteInfo])

  const goNext = () => {
    let message = ''
    Object.keys(state).forEach((key) => {
      if (state[key]?.require === true && state[key]?.agree !== true) {
        message += state[key].title + ', '
      }
    })

    if (message.length <= 0) {
      history.replace({
        pathname: isManager ? '/regis/manager' : '/regis/user',
        state: { agreeInfo: state, userInfo },
      })
    } else {
      message = message.substr(0, message.length - 2)
      props.error({
        title: '약관동의',
        message: message + ' 필수항목에 모두 동의 하셔야 합니다.',
      })
    }
  }

  const checkHandler = (e) => {
    const { id, checked } = e.target

    if (id === 'allChk') {
      setAllCheck(checked)
      setState({
        ...state,
        tosAgreYn: { ...state.tosAgreYn, agree: checked },
        privacyAgreYn: { ...state.privacyAgreYn, agree: checked },
      })
    } else {
      let obj = {
        ...state,
        [id]: { ...state[id], agree: checked },
      }
      // console.log(Object.entries(obj))

      let isCheck = Object.keys(obj).some((key) => obj[key] && obj[key].agree === false)

      setAllCheck(!isCheck)
      setState(obj)
    }
  }

  const toggleAgree = (key1, key2) => {
    setState({
      ...state,
      [key1]: { ...state[key1], show: !state[key1].show },
    })

    if (key2 === 'Y') {
      if (key1 === 'tosAgreYn') {
        const viewer = document.querySelector('#viewer').innerHTML
        setHtmlCode(viewer)
        setShowPrivacy(true)
        setTitle('이용약관')
      }
      if (key1 === 'privacyAgreYn') {
        const viewer = document.querySelector('#privacyViewer').innerHTML
        setHtmlCode(viewer)
        setShowPrivacy(true)
        setTitle('(필수)개인정보 수집 및 이용내역')
      }

    }
  }

  const handleClose = () => {
    setShowPrivacy(false)
  }

  let style = {
    backgroundColor: 'rgb(0, 0, 0)',
    position: 'fixed',
    inset: '0px',
    opacity: '1',
    zIndex: '11',
  }

  let styleModal = {
    position: 'absolute',
    opacity: '1',
    zIndex: '11',
    display: 'block',
  }
  return (
      <React.Fragment>
        <div id="contents">
          {/* <Alert /> */}
          <div className="content-header type2">
            {/* mobile 뒤로가기 버튼 */}
            <a
                onClick={(e) => {
                  e.preventDefault()
                  window.history.back()
                }}
                className="page-prev"
            >
              뒤로이동
            </a>
            <h2>회원가입</h2>
            <div className="breadcrumb">
              <span>Home</span>
              <em>회원가입</em>
            </div>
          </div>
          <div className="join-wrap">
            {props?.checkedJoinFlag === 'user' ? (
                <ul className="steps">
                  <li className="on">
                    <span className="num">1</span>약관동의
                  </li>
                  <li>
                    <span className="num">2</span>본인인증
                  </li>
                  <li>
                    <span className="num">3</span>회원정보 입력
                  </li>
                  <li>
                    <span className="num">4</span>가입완료
                  </li>
                </ul>
            ) : (
                <>
                  <div className="guide-box">
                    <ul className="ulist1">
                      <li>KTNET 사이트 가입을 위한 약관동의 절차입니다.</li>
                      <li>회원가입에 입력한 정보는 암호화되어 안전하게 보관되어 집니다.</li>
                      <li>약관을 동의하지 않을 경우 회원 가입에 제한이 있을 수 있습니다.</li>
                      <li>동일한 사업자일 경우, 최초가입자가 관리자가 되며, 이후 가입자는 법인별 관리자를 통하여 회원가입 가능합니다.</li>
                    </ul>
                    <p className="emphasize">※ 전자무역문서지갑 회원은 만 14세 이상만 가입할 수 있습니다.</p>
                  </div>
                  <ul className="steps mt40">
                    <li className="on">
                      <span className="num">1</span>약관동의
                    </li>
                    <li>
                      <span className="num">2</span>사업자/담당자정보
                    </li>
                    <li>
                      <span className="num">3</span>가입완료
                    </li>
                  </ul>
                </>
            )}
            <div className="tit-wrap">
              <h3 className="h3-tit">(필수) KTNET 이용약관 </h3>
              <span className="right">
              <a className="btn-secondary sm cursor" onClick={() => toggleAgree('tosAgreYn', 'Y')}>
                전문보기
              </a>
            </span>
            </div>
            <div className="policy-box" onClick={() => toggleAgree('tosAgreYn', 'N')}>
              <PolicyTerms />
            </div>
            {/*이용약관에 대한 동의 체크박스*/}
            <div className="check-agree center">
              <input type="checkbox" id="tosAgreYn" require="true" onChange={checkHandler} checked={state.tosAgreYn.agree} />
              <em />
              <label htmlFor="tosAgreYn">위 이용약관에 동의합니다.</label>
            </div>

            <div className="tit-wrap">
              <h3 className="h3-tit">(필수) 개인정보 수집 및 이용내역</h3>
              <span className="right">
              <a className="btn-secondary sm cursor" onClick={() => toggleAgree('privacyAgreYn', 'Y')}>
                전문보기
              </a>
              </span>
            </div>

            <div className="policy-box" onClick={() => toggleAgree('privacyAgreYn', 'N')}>
              <EssentialPrivacy />
            </div>
{/*            <label htmlFor="privacyAgreYn">
              <b style={{ fontWeight: 'bold'}}> ※ 개인정보 수집· 이용 근거법령 : <br />
                &nbsp;&nbsp;&nbsp;&nbsp;- 개인정보 보호법 제15조 제1항 제4호에 의거하여 정보주체와 체결한 계약의 이행을 위해 필요한 경우 <br />
                &nbsp;&nbsp;&nbsp;&nbsp;- 정보주체와 체결한 계약을 이행하거나 계약을 체결하는 과정에서 정보주체의 요청에 따른 조치를 이행하기 위하여 필요한 경우</b></label>
*/}
            <div className="check-agree center">
              <input type="checkbox" id="privacyAgreYn" require="true" onChange={checkHandler} checked={state.privacyAgreYn.agree} />
              <label htmlFor="privacyAgreYn">위 이용약관에 동의합니다.</label>
              <em />
            </div>
            <div className="check-all">
            <input type="checkbox" id="allChk" name="allChk" className="checkbox" onChange={checkHandler} checked={allCheck} />
            <em />
            <label htmlFor="allChk" tabIndex="1">위 이용약관에 모두 동의합니다.</label>
            </div>
            <div className="btn-block center">
              <a className="btn-primary lg cursor" onClick={goNext}>
                다음 단계로
              </a>
            </div>
          </div>
        </div>
        {showPrivacy && (
            <div style={style}>
              {/*  KTNET 이용약관 */}
              <div style={styleModal} className="modal-overlay">
                <div className="modal w1120">
                  <div className="modal-head">
                    <h2>{title}</h2>
                  </div>
                  <div className="modal-cont">
                    <div dangerouslySetInnerHTML={{ __html: htmlCode }} id="policyBox" className="policy-box"></div>
                  </div>
                  <div className="modal-foot">
                    <a href="#" className="btn-primary md" onClick={handleClose}>
                      확인
                    </a>
                  </div>
                  <button type="button" className="modal-close" onClick={handleClose}>
                    창닫기
                  </button>
                </div>
              </div>
              {/*  //KTNET 이용약관 */}
            </div>
        )}
      </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.regis,
    inviteInfo: state.regis?.inviteData?.data?.payload,
    checkedJoinFlag: state.regis.checkedJoinFlag,
  }
}

const actionCreators = {
  success: alertActions.success,
  error: alertActions.error,
  getInviteInfo: regisActions.getInviteInfo,
}

export default connect(mapStateToProps, actionCreators)(RegisStep0)
